import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {FeatureAvodCatalogService} from '@catmodels/avod-catalog/services/feature-avod-catalog.service';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';
import { FeatureAvodCatalogCreateComponent } from './components/feature-avod-catalog-create/feature-avod-catalog-create.component';
import { FeatureAvodCatalogComponent } from './components/feature-avod-catalog/feature-avod-catalog.component';
import {ReactiveFormsModule} from "@angular/forms";
import { ModifyPlaylistComponent } from './components/modify-playlist/modify-playlist.component';
import { CreatePlaylistComponent } from './components/create-playlist/create-playlist.component';
import {FeaturePlaylistService} from "@catmodels/avod-catalog/services/feature-playlist.service";
import {ProjectPlaylistService} from "@catmodels/avod-catalog/services/project-playlist.service";
import { ProjectAvodCatalogComponent } from './components/project-avod-catalog/project-avod-catalog.component';
import {ProjectAvodCatalogService} from "@catmodels/avod-catalog/services/project-avod-catalog.service";
import { ProjectAvodCatalogsComponent } from './components/project-avod-catalogs/project-avod-catalogs.component';
import { ProjectAvodCatalogCreateComponent } from './components/project-avod-catalog-create/project-avod-catalog-create.component';

const publicComponents = [
  FeatureAvodCatalogComponent,
  FeatureAvodCatalogCreateComponent,
  ProjectAvodCatalogsComponent,
  ProjectAvodCatalogComponent,
  ProjectAvodCatalogCreateComponent,
  ModifyPlaylistComponent,
  CreatePlaylistComponent,
];

const exportings = [...publicComponents];

const imports = [
  CommonModule,
  UIBaseModule,
  UIFormModule,
  ReactiveFormsModule,
];

const declarations = [
  ...publicComponents,
];

const providers = [FeatureAvodCatalogService, FeaturePlaylistService, ProjectPlaylistService, ProjectAvodCatalogService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})

export class FeatureAvodCatalogModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/avod-catalog/feature-avod-catalog.module.ts